import axios from "axios";
import { message } from 'antd';
import { getCookie, CANONICAL_COUNTRY_CODE, ORGANIZATION_ID, UTC_OFFSET, LANG, urlAddQuery, USER_ID, USER_NAME } from "@/utils"

// shiro在验证sso时如果有此参数则不会做302，是200且返回对应的登录地址
const FROM: Array<string> = ['X-Requested-With', 'dataType', 'accept', 'contentType', 'cache-control']
const TO: Array<string> = ['XMLHttpRequest', 'json', 'application/json', 'application/json;charset=utf-8', 'no-cache']
const METHODS: Array<string> = ['get', 'post', 'put', 'delete']
    ; (() => {
        METHODS.every((current, index, array) => {
            FROM.every((cur, ind, arr) => {
                axios.defaults.headers[current][cur] = TO[ind]
                return true
            })
            return true
        })
    })()

export const axiosInstance = axios.create({
    // baseURL: config.baseUrl,
    timeout: 90000,
    withCredentials: false,
    headers: {
        "ssoticket": getCookie("ssoticket")
    }
});

// 登录验证
const redirect = (r: any) => {
    if (r && r.data && r.data.redirectUrl) {
        let win
        let t = r.data.redirectUrl
        if (window.parent && window.parent.location) {
            win = window.parent
        } else {
            win = window
        }
        t += ~t.indexOf('?') ? `&jumpto=${encodeURIComponent(win.location.href)}` : `?jumpto=${encodeURIComponent(win.location.href)}`
        win.location.href = t
    } else {
        return r
    }
}

let argsLang = LANG.replace(/-/g, "_") // 后端需要把中划线换成下划线 zh-CN =》 zh_CN

axiosInstance.interceptors.request.use(
    function (config): any {
        let paramsConfig = {
            orgId: ORGANIZATION_ID,
            countryCode: CANONICAL_COUNTRY_CODE,
            utcOffset: UTC_OFFSET,
            lang: argsLang,
            userId: USER_ID, // 非公参 记得删除掉
            userName: USER_NAME, // 非公参 记得删除掉
            canonical_country_code: CANONICAL_COUNTRY_CODE,
            utc_offset: UTC_OFFSET,
            organization_id: ORGANIZATION_ID,
        }

        // 设置公共参数
        if (config.method === "get") {
            if (config.params) {
                Object.assign(config.params, paramsConfig)
            }
        } else if (config.method === "post") {
            Object.assign(config.data, paramsConfig)
            config.url = urlAddQuery(config.url, paramsConfig)
        }

        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
)

axiosInstance.interceptors.response.use(
    function (response): any {
        const data = response.data;
        if (data.status !== 0) {
            if (data.status === 2) {
                redirect(data)
                return
            }
            if (data.status === 100) { // 没权限
                let msg = data?.data?.detail_message || '没权限'
                message.warn(msg);
            }
            let errorArgs = data.error + ' ' + data?.data?.traceid || "发生错误!"
            message.error(errorArgs);
            return Promise.reject(data.error);
        }
        return response;
    },
    function (error) {
        let errorArgs = String(error) || "发生错误!"
        message.error(errorArgs)
        return Promise.reject(error)
    }
)

const axiosConfig = { axiosInstance }
export default axiosConfig;